/**
 * @module components/YAxisSetting/YAxisRangeSwitch
 * @description Y 轴范围开关 — 显示范围：自动区间
 *
 * 支持图表：柱状图、堆叠图、折线图、事件折线图
 * 不触发重算（yAxisRangeSwitch 在 notCalculateKey 中）
 */
import React, { useCallback } from 'react';
import { useIntl } from 'umi';
import { Switch } from 'tea-component';
import TipContext from '@home/components/TipContext';
import { useSettingState } from '../../../context';
// import './index.scss';

const YAxisRangeSwitch: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value: currentValue, setValue: setYAxisRangeSwitch } =
    useSettingState('yAxisRangeSwitch');

  const handleChange = useCallback(
    (value: boolean) => {
      setYAxisRangeSwitch(value);
    },
    [setYAxisRangeSwitch],
  );

  return (
    <div className="dbl-chart-setting-row">
      <div className="dbl-lable-gray-font dbl-horizontal-center">
        {formatMessage({ id: 'dbl_chart_yaxis_range_title' })}
        <TipContext
          className="dbl-tipcontext-left-margin"
          placement="top-end"
          placementOffset={[18, 10]}
          tipText={formatMessage({ id: 'dbl_chart_yaxis_range_tip' })}
        />
      </div>
      <Switch value={currentValue} onChange={handleChange} />
    </div>
  );
};

export default React.memo(YAxisRangeSwitch);
